/**
 * @author xyguo
 * @description 主持人列表
 * @Date 2020/10/20
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool,utils_tool ,component_tool} from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let {  WizBrowserExport } = component_tool;

class hostList extends WizContainer {

  componentName = 'hostList';

  constructor(props) {
    super(props);
    this.state = {}
  }


  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          //val['name'] = checkStrLength(val['name'], len);
          val['startDate'] = val['startDate'].substring(0,val['startDate'].length-3)
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleGetUrlData(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      window.open(o['data'], '_blank')
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        list: this._handleListData,
        getUrl: this._handleGetUrlData,
        getWebUploadBackPlayUrl: this._handleGetUrlData,
      },

})
return <WizReduxTemplate {..._reduxTemplateCofig}  />
}
}


const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(hostList);
